import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataNatcomAirtimCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../components/DashboardCompare";

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { data: ntm = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChart = useMemo(() => {
    const convertData = formatDataNatcomAirtimCompate(ntm, startDate, endDate, true);
    return convertData || [];
  }, [ntm, startDate, endDate]);

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      <div>
        <DashboardCompare
          dataChart={dataChart}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    </>
  );
}
